import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert } from "react-bootstrap";

export const ErrorAdminAccount = () => {
    // Uncaught ReferenceError: path is not defined
    return <Alert variant='warning'><FontAwesomeIcon icon={faTriangleExclamation} className="warning-icon"/> Use your admin account for the self service (the @admin.hubtotal.net account).</Alert>;
    
}